import { Fragment } from "react";
import {useHistory} from "react-router-dom";

import { Card, CardActionArea, CardContent, Typography } from "@mui/material";
import Grid from '@mui/material/Grid2'

import {SITE_ROUTE} from "../../lib/routes";

export default function SitesGrid({sites}) {
  const history = useHistory();
///DEVO SEMPRE CONTROLLARE CHE SIA UN ARRAY ALTRIMENTI VA IN ERRORE
  if (!Array.isArray(sites)) {
    sites = Object.values(sites).flat(); 
  }

  return (
    <Fragment>
      {sites.map(({id: siteId, brand, name}, index) => (
        <Grid item size={{xs:12, sm:6, md:4}} key={siteId}>
          <Card variant="outlined" className={index === 0 ? "site-card" : ""}>
            <CardActionArea onClick={() => history.push(SITE_ROUTE.computePath({siteId}))}>
              <CardContent>
                <Typography variant="h5" component="h2">
                  {brand}
                </Typography>
                <Typography color="textSecondary">
                  {name}
                </Typography>
              </CardContent>
            </CardActionArea>
          </Card>
        </Grid>
      ))}
    </Fragment>
  );
}
